import { Link } from '@ctw/shared/components/link';
import {
  isInlineTextElement,
  uniqueIdentifierForNode,
} from '@ctw/shared/content/document-viewer/_internal/renderers/helpers';
import { DOCUMENT_VIEWER_LINK_TEST_ID } from '@ctw/shared/test/ids';
import { isEmpty } from 'lodash-es';
import type { CdaSection } from '../../parsers/types';
import { ReactNodeRenderer } from './react-node-renderer';

interface ReactLinkRendererProps {
  section: CdaSection;
  link: HTMLElement;
}

export const ReactLinkRenderer = ({ section, link }: ReactLinkRendererProps) => {
  const href = link.attributes.getNamedItem('href')?.textContent?.trim();

  if (isEmpty(href)) {
    return <></>;
  }

  const childrenIsSoloTextElement =
    link.childNodes.length === 1 && isInlineTextElement(link.childNodes[0]);

  return (
    <Link
      href={link.attributes.getNamedItem('href')?.textContent ?? ''}
      dataTestId={DOCUMENT_VIEWER_LINK_TEST_ID}
    >
      {childrenIsSoloTextElement && link.childNodes[0].textContent}
      {!childrenIsSoloTextElement &&
        Array.from(link.childNodes).map((child) => (
          <ReactNodeRenderer
            id={uniqueIdentifierForNode({ section, node: child, context: 'link-child' })}
            key={uniqueIdentifierForNode({ section, node: child, context: 'link-child' })}
            node={child}
            section={section}
          />
        ))}
    </Link>
  );
};
